import { IFundStats } from '../interfaces';

interface ICreateRiskReturnSerie {
  data: number[][];
  name: string;
  color: string;
  type: string;
  id: string;
}

export const createRiskReturnSerie = (
  assetsStats: IComparisonStatsProps[] | IFundStats[]
): ICreateRiskReturnSerie[] => {
  if (!assetsStats) return;

  const serie = assetsStats.map((quotes: IComparisonStatsProps) => {
    const { volatility, profitability } =
      quotes.stats?.timeframe.last_12_months;
    const { volatility: volatilityBegin, profitability: profitabilityBegin } =
      quotes.stats.timeframe?.begin;

    return {
      data: [
        [volatility || volatilityBegin, profitability || profitabilityBegin],
      ],
      name: quotes.nicename,
      color: quotes.color,
      type: 'scatter',
      id: quotes.id,
    };
  });

  return serie;
};

interface IComparisonStatsProps {
  nicename: string;
  id?: string;
  color?: string;
  stats: IStats;
}

interface IStats {
  best_monthly_return: number;
  worst_monthly_return: number;
  positive_months: number;
  negative_months: number;
  timeframe: ITimeframeStats;
  '12_months_average_networth'?: number;
  networth?: number;
  quota_holders?: number;
  years?: IStatsYearType;
  positive_months_percent?: number;
  negative_months_percent?: number;
}

interface ITimeframeStats {
  last_3_months: IStatsMonth;
  last_6_months: IStatsMonth;
  last_12_months: IStatsMonth;
  last_24_months: IStatsMonth;
  last_36_months: IStatsMonth;
  ytd: IStatsMonth;
  mtd: IStatsMonth;
  begin: IStatsMonth;
}

interface IStatsMonth {
  profitability: number;
  volatility: number;
  sharpe_ratio: number;
}

interface IStatsYear {
  '1'?: number;
  '2'?: number;
  '3'?: number;
  '4'?: number;
  '5'?: number;
  '6'?: number;
  '7'?: number;
  '8'?: number;
  '9'?: number;
  '10'?: number;
  '11'?: number;
  '12'?: number;
  year: number;
  accrued: number;
}

type IStatsYearType = Record<string, IStatsYear>;
